import { render, staticRenderFns } from "./ToothPicker.vue?vue&type=template&id=557a05db&"
import script from "./ToothPicker.vue?vue&type=script&lang=js&"
export * from "./ToothPicker.vue?vue&type=script&lang=js&"
import style0 from "./ToothPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports